/* eslint-disable extra-rules/no-commented-out-code */
import moment from 'moment';

export const dateFormats = [
  'ddd MMM D YYYY HH:mm:ss [GMT]ZZ', // Mon Apr 03 2023 09:07:57 GMT-0400
  'MMM D, YYYY [at] h:mm:ss A', // Apr 3, 2023 at 8:13:52 AM
  'M/D/YYYY', // 04/12/2023
  'M/D/YY', // 04/12/23
  'M/D/YYTHH:mm', // 1/19/22T03:30
  'M/D/YY HH:mm', // 11/1/22 03:00
  'ddd MMM D,YYYY', // Mon Apr 03,2023
  'MMM D YYYY', // Mar 30 2023
  'MMM D, YYYY', // Apr 03, 2023
  'MMMM[T]D[,][T]YYYY', // MarchT29,T2023
  'MMMM DD, YYYY',
  'MMMM D, YYYY',
  'MM-DD-YYYY',
  // add more formats here
];

export const convertDateWithSlash = (input) => {
  if (typeof input === 'string') {
    if (moment(input, true).isValid()) {
      return moment(input).toDate();
    }
    const matchingFormat = dateFormats.find((format) => moment(input, format, true).isValid());
    return matchingFormat ? moment(input, matchingFormat).toDate() : new Date();
  }
  return input ? new Date(input) : new Date();
};
